import gsap from 'gsap';

export default function luxembourgMap() {

    if ($('.luxembourg-map').length > 0) {
        $('.mapMarker').on('mouseover', function () {
            const img_url = $(this).attr('data-img');
            const projects_nbr = $(this).attr('data-projects');

            $('.tooltip').css('background-image', 'url("' + img_url + '")');
            $('.tooltip span').text(projects_nbr);
            $('.tooltip').fadeIn(300);
        })

        $('.mapMarker').on('mouseleave', function () {
            setTimeout(function () {
                $('.tooltip').fadeOut(200);
            }, 50)
            setTimeout(function () {
                $('.tooltip span').text('0');
            }, 250)
        })

        const cursor = $('.tooltip');
        $(window).on('mousemove', function (e) {
            let clientX = e.pageX;
            let clientY = e.pageY;

            gsap.set(cursor, {
                top: clientY - 35 - $('.page-hero').innerHeight(),
                left: clientX,
            });
        })
    }
}


// WEBPACK FOOTER //
// ./scripts/modules/luxembourgMap.js